export default __webpack_public_path__ + "static/media/vi_historietas_Novela_grafica.9bbd51c1.mp4";